import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const { register, user, loading } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", company: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/" replace />;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await register(form);
    setSubmitting(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid place-items-center auth-grid p-6">
      <form onSubmit={submit} className="card-elev w-full max-w-md p-10" data-testid="register-form">
        <div className="flex items-center gap-2.5 mb-6">
          <div className="w-10 h-10 grid place-items-center bg-[var(--rqp-orange)] rounded-sm">
            <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinejoin="round">
              <path d="M3 12 L12 4 L21 12 L18 12 L18 20 L6 20 L6 12 Z" />
            </svg>
          </div>
          <div>
            <div className="font-display font-bold text-lg leading-none">RoofQuote</div>
            <div className="text-[10px] font-bold tracking-[0.18em] text-[var(--rqp-orange)] uppercase">PRO</div>
          </div>
        </div>
        <span className="hero-rule" />
        <div className="overline">Sign up</div>
        <h2 className="font-display text-4xl font-bold tracking-tight mt-2">Create your account</h2>

        {error && (
          <div className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2 rounded-sm" data-testid="register-error">
            {error}
          </div>
        )}

        <label className="block mt-5">
          <span className="overline">Full name</span>
          <input data-testid="register-name-input" required value={form.name} onChange={set("name")} className="rqp mt-1.5" />
        </label>
        <label className="block mt-4">
          <span className="overline">Company (optional)</span>
          <input data-testid="register-company-input" value={form.company} onChange={set("company")} className="rqp mt-1.5" />
        </label>
        <label className="block mt-4">
          <span className="overline">Email</span>
          <input data-testid="register-email-input" type="email" required value={form.email} onChange={set("email")} className="rqp mt-1.5" />
        </label>
        <label className="block mt-4">
          <span className="overline">Password (min 6)</span>
          <input data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={set("password")} className="rqp mt-1.5" />
        </label>

        <button data-testid="register-submit-button" type="submit" disabled={submitting} className="btn-primary w-full mt-6 disabled:opacity-60">
          {submitting ? "Creating…" : "Create account"}
        </button>

        <div className="mt-6 text-sm text-slate-600">
          Already have an account?{" "}
          <Link to="/login" data-testid="register-to-login-link" className="text-[var(--rqp-orange)] font-semibold hover:underline">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
